"use client";

import React, { useState, useEffect } from "react";
import axios from "axios";
import globalVariables from "GlobalVariable";
import Turnstile, { useTurnstile } from "react-turnstile";

import "App.css";

import SubmissionModal from "components/SubmissionModal";

const FormRoyal = ({ idTrackGoogleAds, id2 }) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    service: "",
  });

  const [errors, setErrors] = useState({});
  const [captchaIsPassed, setCaptchaIspassed] = useState(false);
  const [vefifyCaptcha, setVerifyCaptcha] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [modalState, setModalState] = useState(null);
  const [businessData, setBusinessData] = useState(null);

  useEffect(() => {
    const fetchBusinessData = async () => {
      try {
        const response = await axios.get(`${globalVariables.domain}/business/royal`);
        // console.log(response.data, "dataaaa");
        if (response.data && response.data.content) {
          setBusinessData(response.data.content);
        }
      } catch (error) {
        console.error("Error fetching business data:", error);
      }
    };
    fetchBusinessData();
  }, []);

  const turnstile = useTurnstile();

  // --- FUNCIÓN PARA FORMATEAR TELÉFONO ---
  const formatPhoneNumber = (value) => {
    // Extraer todos los dígitos
    const digits = value.replace(/\D/g, '');

    let baseNumber = digits;
    // Si el primer dígito es un 1, lo tratamos como el prefijo de país y usamos los siguientes 10
    if (digits.startsWith('1')) {
      baseNumber = digits.slice(1);
    }

    const limited = baseNumber.slice(0, 10);

    if (limited.length === 0) {
      return digits.length > 0 ? "+1 " : "";
    }

    let formatted = "+1 ";
    if (limited.length > 0) {
      formatted += `(${limited.slice(0, 3)}`;
    }
    if (limited.length > 3) {
      formatted += `) ${limited.slice(3, 6)}`;
    }
    if (limited.length > 6) {
      formatted += `-${limited.slice(6)}`;
    }

    return formatted;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Formatear teléfono si es el campo phone
    if (name === "phone") {
      const formatted = formatPhoneNumber(value);
      setFormData((prev) => ({
        ...prev,
        [name]: formatted,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "This field is required";

    // Validar teléfono: debe tener el prefijo +1 y 10 dígitos (total 11 dígitos extraídos)
    const phoneDigits = formData.phone.replace(/\D/g, '');
    if (!formData.phone.trim() || formData.phone === "+1 ") {
      newErrors.phone = "This field is required";
    } else if (phoneDigits.length !== 11) {
      newErrors.phone = "Phone number must be valid";
    }

    if (!formData.service.trim() || formData.service === "Select Service")
      newErrors.service = "This field is required";
    return newErrors;
  };

  function obtenerTimestampActual() {
    return Date.now();
  }

  const gtag_report_conversion = (url) => {
    const callback = () => {
      if (typeof url !== "undefined") {
        window.location = url;
      }
    };
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: `${idTrackGoogleAds}/${id2}`,
        event_callback: callback,
      });
    }
    return false;
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${idTrackGoogleAds}`;
    document.head.appendChild(script);

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", `${idTrackGoogleAds}`);
    };

    return () => {
      document.head.removeChild(script);
    };
  }, [idTrackGoogleAds]);

  const saveLead = async () => {

    try {
      // Obtener solo los dígitos del teléfono (sin formato) para el backend
      const phoneDigits = formData.phone.replace(/\D/g, '');

      const data = {
        conversationId: "N/A",
        locationId: "manual",
        lastMessageDate: obtenerTimestampActual(),
        fullName: formData.name,
        tags: [formData, "royal web form"],
        phone: phoneDigits, // Enviar solo dígitos sin formato
        business_yelp_id: "royal",
        lead_source: "form",
      };
      await axios.post(
        `${globalVariables.domain}/lead_systematik/`,
        data
      );
      gtag_report_conversion();
    } catch (error) {
      console.error("Error saving lead:", error);
      throw error;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    if (!captchaIsPassed) {
      setVerifyCaptcha(true);
      return;
    }

    setIsSubmitting(true);
    setModalState('submitting');
    setErrors({});

    try {
      await saveLead();
      setModalState('success');
    } catch (error) {
      console.error("Form submission error:", error);
      setModalState('error');
    }
  };

  const handleCloseModal = () => {
    setModalState(null);
    setIsSubmitting(false);
    if (modalState === 'success') {
      setFormData({ name: "", phone: "", service: "" });
      if (turnstile) turnstile.reset();
      setCaptchaIspassed(false);
      setVerifyCaptcha(false);
    }
  };

  return (
    <>
      <SubmissionModal
        state={modalState}
        onClose={handleCloseModal}
        companyName={businessData?.business_name || "Royal"}
        phoneNumber={businessData?.phone_web || businessData?.main_phone || businessData?.phone_google || businessData?.phone_yelp || "+1 (408) 509-0579"}
      />
      <div className="flex flex-col items-center justify-center min-h-screen bg-transparent">
        <div className="max-w-xl rounded-lg">
          <h2 className="text-3xl text-white font-extrabold mb-4 uppercase text-center">
            Call, text or submit form for immediate response 24/7
          </h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                disabled={isSubmitting}
                className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 ${errors.name ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
                  }`}
              />
              {errors.name && <p className="mt-1 text-sm text-red-500">{errors.name}</p>}
            </div>
            <div>
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                disabled={isSubmitting}
                autoComplete="tel"
                maxLength={17}
                className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 ${errors.phone ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
                  }`}
              />
              {errors.phone && <p className="mt-1 text-sm text-red-500">{errors.phone}</p>}
            </div>
            <div>
              <select
                name="service"
                value={formData.service}
                onChange={handleChange}
                disabled={isSubmitting}
                className={`w-full px-4 py-2 border rounded-lg bg-white focus:outline-none focus:ring-2 ${errors.service ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
                  }`}
              >
                <option value="" disabled>Select Service</option>
                <option value="Carpet Cleaning">Carpet Cleaning</option>
                <option value="Grout Services">Grout Services</option>
                <option value="Pressure Washers">Pressure Washers</option>
              </select>
              {errors.service && <p className="mt-1 text-sm text-red-500">{errors.service}</p>}
            </div>
            <div>
              <Turnstile
                sitekey="0x4AAAAAAA11EXR57l9M1Gd2"
                onVerify={() => setCaptchaIspassed(true)}
                theme="light"
              />
            </div>
            {!captchaIsPassed && vefifyCaptcha && (
              <p className="mt-1 text-sm text-red-500">This field is required</p>
            )}
            <div>
              <button
                type="submit"
                disabled={isSubmitting}
                className={`w-full px-4 py-2 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 transition-colors duration-300 ${isSubmitting ? "bg-gray-400 cursor-not-allowed" : "bg-[#CA0712] hover:bg-red-700"
                  }`}
              >
                {isSubmitting ? "Submitting..." : "Request Service"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default FormRoyal;
